import $ from 'jquery';

$(function () {

    const $body = $('body');
    const inBackend = $body.hasClass('neos-backend');

    if (inBackend) return;

    $('.floater').each(function () {

        const animationDuration = 600;
        const waitDuration = 3500;
        const spaceAfter = 8;

        const $floater = $(this);
        const $floaterElements = $floater.find('.floater-element');
        const elementCount = $floaterElements.length;
        let $currentElement = $floaterElements.eq(0);

        // Init
        $currentElement.css({
            top: 0,
            opacity: 1,
        });
        $floater.css({
            paddingLeft: ($currentElement.outerWidth() + spaceAfter) + 'px',
        });



        let currentElementIndex = 0;
        let floaterInterval = setInterval(function () {

            // Cancel after first round
            if (currentElementIndex + 1 >= elementCount) {
                clearInterval(floaterInterval);
                return;
            }

            currentElementIndex = (currentElementIndex + 1) % elementCount;


            const $nextElement = $floaterElements.eq(currentElementIndex);

            revealElement($nextElement);
        }, waitDuration);


        function revealElement($nextElement) {

            const nextElementWidth = $nextElement.outerWidth() + spaceAfter;

            $nextElement.css({
                top: '-2rem',
            });

            $nextElement.animate({
                top: 0,
                opacity: 1,
            }, animationDuration);

            if ($currentElement) {
                $currentElement.animate({
                    top: '2rem',
                    opacity: 0
                }, animationDuration);
            }

            $floater.animate({
                paddingLeft: nextElementWidth + 'px',
            }, animationDuration);


            $currentElement = $nextElement;

        }


    });

});
